// @owners { team: patients }
import { type ShipmentTip } from '@alto/scriptdash/alto/orders/types/v1/shipment_tip';
import { createQueryKeys } from '@lukemorales/query-key-factory';
import api from '~shared/features/courier-tips/api';
import { queryClient } from '~shared/react-query/queryClient';
import { type User } from '~shared/types';
import { type APIError } from '~shared/types/APIError';

export const shipmentTips = createQueryKeys('shipmentTips', {
  fetchForUser: (userID: User['id']) => ({
    queryKey: [userID],
    queryFn: async (): Promise<ShipmentTip[]> => {
      // Failed responses resolve (not reject) with an `error` field, so check it explicitly.
      const { data, error } = (await api.fetchShipmentTipsForUser({ user_id: userID })) as {
        data: ShipmentTip[];
        error?: APIError;
      };
      if (error) {
        throw error;
      }
      return data;
    },
  }),
});

/**
 * Invalidate the shipment-tips query (all users) so the bridge at the authed root refetches.
 * Scoped to the `fetchForUser` subkey rather than the factory root so adding future shipmentTips
 * queries won't be unintentionally invalidated here. Store-free so action files and mutation hooks
 * can call it without pulling the store into their import graph — avoids the store↔actions cycle.
 */
export const invalidateShipmentTips = () => queryClient.invalidateQueries({ queryKey: shipmentTips.fetchForUser._def });
